<div class="flex flex-col h-full">
  <div class="flex py-2 justify-between">
    <div class="flex w-1/5">
      <elcia-search [control]="filterForm.controls.searchTerm"/>
    </div>
    <elcia-button (onClick)="showForm()" [icon]="'plus'" [label]="'action.add-tax' | translate"/>
  </div>

  <div class="flex-1 overflow-hidden">
    <elcia-accounting-tax-grid
      (onDelete)="deleteTax($event)"
      (onEdit)="openEditForm($event)"
      [isLoading]="isLoading()"
      [taxes]="taxes()"/>
  </div>
</div>

@if (isFormDisplayed()) {
  <elcia-dialog
    (onAction)="onDialogSave()"
    (onClose)="closeForm()"
    [isActionLoading]="isSaving()"
    [mustDisplayDeleteButton]="false"
    [size]="'medium'"
    [title]="'entity.tax' | translate">
    <elcia-accounting-tax-form
      (onSubmit)="onFormSubmit($event)"
      [initialValue]="selectedTax()"/>
  </elcia-dialog>
}

<elcia-confirm-dialog/>
